import { useRender } from '@base-ui/react/use-render'
import { useId } from 'react'

import { cn } from '../../../../lib/utils.ts'

import { useRegisterItemMetadata } from './item-metadata-context.ts'

export function ItemDescription(props: ItemDescription.Props) {
  const { className, id, ref, ...rest } = props
  const generatedId = useId()
  const resolvedId = id ?? generatedId
  useRegisterItemMetadata('description', resolvedId)
  return useRender({
    ref,
    defaultTagName: 'span',
    props: {
      id: resolvedId,
      'data-slot': 'item-description',
      className: cn('text-20 leading-30 font-400 text-content-base-basic', className),
      ...rest,
    },
  })
}
export namespace ItemDescription {
  export type Props = React.ComponentProps<'span'>
}
